import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { env } from "../../../../../env";

const legacyUrl = env.REACT_APP_LEGACY_URL;
// Action
export const getInstantpayPendingTxn = createAsyncThunk(
  "getInstantpayPendingTxn",
  async () => {
    var requestOptions = {
      method: "POST",
      redirect: "follow",
      headers: {
        "Content-Type": "application/json",
        "X-Api-Key": sessionStorage.getItem("q2p_token"),
      },
      body: JSON.stringify({
        approval_status: "P",
        page_no: null,
        page_size: null,
      }),
    };

    return await fetch(
      `${legacyUrl}/transactions/Instant_pay/view_all`,
      requestOptions
    )
      .then((response) => response.json())
      .catch((error) => (() => {})());
  }
);
export const getVendorPendingAccount = createAsyncThunk(
  "getVendorPendingAccount",
  async (values) => {
    var requestOptions = {
      method: "POST",
      redirect: "follow",
      headers: {
        "Content-Type": "application/json",
        "X-Api-Key": sessionStorage.getItem("q2p_token"),
      },
      body: JSON.stringify({
        page_no: values?.page_no || 0,
        page_size: 50,
        approval_status: "P",
        search_string: values?.search_string,
      }),
    };

    return await fetch(`${legacyUrl}/accounts/vendor/view`, requestOptions)
      .then((response) => response.json())
      .catch((error) => (() => {})());
  }
);

export const getFieldForcePendingAccount = createAsyncThunk(
  "getFieldForcePendingAccount",
  async (values) => {
    var requestOptions = {
      method: "POST",
      redirect: "follow",
      headers: {
        "Content-Type": "application/json",
        "X-Api-Key": sessionStorage.getItem("q2p_token"),
      },
      body: JSON.stringify({
        approval_status: "P",
        page_no: values?.page_no || 0,
        page_size: 15,
      }),
    };

    return await fetch(`${legacyUrl}/accounts/field_force/view`, requestOptions)
      .then((response) => response.json())
      .catch((error) => (() => {})());
  }
);
export const getInternalPendingTxn = createAsyncThunk(
  "getInternalPendingTxn",
  async () => {
    var requestOptions = {
      method: "POST",
      redirect: "follow",
      headers: {
        "Content-Type": "application/json",
        "X-Api-Key": sessionStorage.getItem("q2p_token"),
      },
      body: JSON.stringify({
        approval_status: "P",
        page_no: null,
        page_size: null,
      }),
    };

    return await fetch(
      `${legacyUrl}/transactions/owner/internal_fund_transfer/view_all`,
      requestOptions
    )
      .then((response) => response.json())
      .catch((error) => (() => {})());
  }
);
export const getClientPendingTxn = createAsyncThunk(
  "getClientPendingTxn",
  async () => {
    var requestOptions = {
      method: "POST",
      redirect: "follow",
      headers: {
        "Content-Type": "application/json",
        "X-Api-Key": sessionStorage.getItem("q2p_token"),
      },
      body: JSON.stringify({
        approval_status: "P",
        page_no: null,
        page_size: null,
      }),
    };

    return await fetch(
      `${legacyUrl}/transactions/client/view_all`,
      requestOptions
    )
      .then((response) => response.json())
      .catch((error) => (() => {})());
  }
);
export const getReimbursementPendingTxn = createAsyncThunk(
  "getReimbursementPendingTxn",
  async () => {
    var requestOptions = {
      method: "POST",
      redirect: "follow",
      headers: {
        "Content-Type": "application/json",
        "X-Api-Key": sessionStorage.getItem("q2p_token"),
      },
      body: JSON.stringify({
        approval_status: "P",
        page_no: 0,
        page_size: 50,
      }),
    };

    return await fetch(
      `${legacyUrl}/transactions/reimbursement/view_all`,
      requestOptions
    )
      .then((response) => response.json())
      .catch((error) => (() => {})());
  }
);

const pendingTxnSlice = createSlice({
  name: "pendingTxn",
  initialState: {
    isLoading: false,
    instantpay: null,
    vendor: null,
    fieldForce: null,
    internal: null,
    client: null,
    reimbursement: null,
    isError: false,
  },
  extraReducers: (builder) => {
    //Instantpay
    builder.addCase(getInstantpayPendingTxn.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getInstantpayPendingTxn.fulfilled, (state, action) => {
      state.isLoading = false;
      state.instantpay = action.payload;
    });
    builder.addCase(getInstantpayPendingTxn.rejected, (state, action) => {
      (() => {})();
      state.isError = true;
    });
    //Vendor
    builder.addCase(getVendorPendingAccount.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getVendorPendingAccount.fulfilled, (state, action) => {
      state.isLoading = false;
      state.vendor = action.payload;
    });
    builder.addCase(getVendorPendingAccount.rejected, (state, action) => {
      (() => {})();
      state.isError = true;
    });
    //FieldForce
    builder.addCase(getFieldForcePendingAccount.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getFieldForcePendingAccount.fulfilled, (state, action) => {
      state.isLoading = false;
      state.fieldForce = action.payload;
    });
    builder.addCase(getFieldForcePendingAccount.rejected, (state, action) => {
      (() => {})();
      state.isError = true;
    });
    //Internal
    builder.addCase(getInternalPendingTxn.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getInternalPendingTxn.fulfilled, (state, action) => {
      state.isLoading = false;
      state.internal = action.payload;
    });
    builder.addCase(getInternalPendingTxn.rejected, (state, action) => {
      (() => {})();
      state.isError = true;
    });
    //Client
    builder.addCase(getClientPendingTxn.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getClientPendingTxn.fulfilled, (state, action) => {
      state.isLoading = false;
      state.client = action.payload;
    });
    builder.addCase(getClientPendingTxn.rejected, (state, action) => {
      (() => {})();
      state.isError = true;
    });
    //Reimbursement
    builder.addCase(getReimbursementPendingTxn.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getReimbursementPendingTxn.fulfilled, (state, action) => {
      state.isLoading = false;
      state.reimbursement = action.payload;
    });
    builder.addCase(getReimbursementPendingTxn.rejected, (state, action) => {
      (() => {})();
      state.isError = true;
    });
  },
});

export default pendingTxnSlice.reducer;
